export function safeIntCast(n?: any): number {
	if (!n || typeof n !== "number") {
		return 0;
	}
	return n;
}
